module.exports = __webpack_public_path__ + "static/media/6_4.75f2274c.jpg";